export type ResourceCalendarGanttTranslation = {
  continuesAfter: string;
  continuesBefore: string;
  elementColumn: string;
  phase: {
    assembly: string;
    disassembly: string;
  };
  status: {
    confirmed: string;
    free: string;
    tentative: string;
  };
  timelineAriaLabel: string;
  weekday: {
    friday: string;
    monday: string;
    saturday: string;
    sunday: string;
    thursday: string;
    tuesday: string;
    wednesday: string;
  };
};

export const resourceCalendarGanttTranslation: ResourceCalendarGanttTranslation = {
  continuesAfter: 'Kontynuacja w kolejnych dniach',
  continuesBefore: 'Kontynuacja z poprzednich dni',
  elementColumn: 'Element',
  phase: {
    assembly: 'Montaż',
    disassembly: 'Demontaż',
  },
  status: {
    confirmed: 'Rezerwacja potwierdzona',
    free: 'Wolny',
    tentative: 'Rezerwacja wstępna',
  },
  timelineAriaLabel: 'Harmonogram Gantta zajętości elementów słownika',
  weekday: {
    friday: 'Pt',
    monday: 'Pn',
    saturday: 'So',
    sunday: 'Nd',
    thursday: 'Cz',
    tuesday: 'Wt',
    wednesday: 'Śr',
  },
};
